/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import { X } from '@jda/lui-common-icon-library-mui5';
import { useStyles } from './styles';

interface IDetailsModalProps {
  children: React.ReactNode;
  handleClose: Function;
  dialogTitle: string;
  openModal: boolean;
  maxWidth?: 'lg' | 'md' | 'sm' | 'xl' | 'xs' | false;
  height?: string;
}

const DetailsModal = (props: IDetailsModalProps) => {
  const { classes } = useStyles();
  const { children, dialogTitle, openModal, handleClose, maxWidth } = props;
  return (
    <Dialog classes={{ scrollPaper: classes.scrollPaper }} open={openModal} fullWidth maxWidth={maxWidth}>
      <DialogTitle id="form-dialog-title">
        <Box className={classes.flex}>
          <Box>{dialogTitle}</Box>
          <IconButton
            size="small"
            id="closeBox"
            classes={{ root: classes.closeButton }}
            onClick={() => {
              handleClose();
            }}
          >
            <X />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>{children}</DialogContent>
    </Dialog>
  );
};

export default DetailsModal;
